module.exports = __webpack_public_path__ + "img/megaphone.ef15ff08.png";